/* eslint @typescript-eslint/no-empty-function: 0 */
import React from 'react'
import { OrderStatus } from '../../../../enums/order.enum'
import { tableOrderStatusLabel } from '../../../../helpers/helper-order'

import {
  Container,
  Status,
  RightWrapper,
} from './styles'

export type OrderProps = {
  status: 0 | 1 | 2;
  name: string;
  id: number;
  isUniqueOrderWrapper: boolean;
}

type Props = {
  order: OrderProps;
  isSelected?: boolean;
  onClick?: () => void;
}

const OrderCard = ({
  order,
  onClick = () => {},
  isSelected = false,
}: Props) => (
  <Container code={order.status ?? 2} onClick={onClick} selected={isSelected}>
    <div>
      <Status code={order.status ?? 2}>{tableOrderStatusLabel[order.status ?? 2]}</Status>
      <p>
        Mesa:
        {' '}
        {order.name}
      </p>
    </div>

    <RightWrapper>
      { order.isUniqueOrderWrapper === false
          && order.status === OrderStatus.WAITING_PAYMENT
          && (<strong>Pagamento parcial</strong>)}
      <span>Ver detalhes</span>
    </RightWrapper>
  </Container>
)

OrderCard.defaultProps = {
  isSelected: false,
  onClick: () => {},
}

export default OrderCard
